import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  actions: {
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
  },
  cover: {
    marginBottom: theme.spacing(1),
    '& img': {
      maxWidth: '350px',
      maxHeight: '175px',
      borderRadius: 10,
      objectFit: 'cover',
    },
  },
  coverRemove: {
    marginLeft: theme.spacing(1),
  },
  previewBar: {
    position: 'relative',
  },
  previewTitle: {
    flex: 1,
    color: 'inherit',
  },
  previewContent: {
    padding: theme.spacing(4, 2),
  },
}));
